export default "__VITE_ASSET__60a03980__"